import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { Vehicle, vehicleSchema } from '../schemas/vehicle.schema';

/**
 * Creates an array of new Vehicles
 * @param vehicles The Vehicles being created
 * @returns Data object containing the newly created Vehicles
 */
export function postVehicles(this: unknown, vehicles: Partial<Vehicle>[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).vehiclesUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(vehicles),
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(vehicleSchema),
      })
    )
  );
}
